import { useState } from "react";
import React from 'react';

const ContextAlert = React.createContext();

const ProviderAlert = ({children}) => {
const [show, setShow] = useState(false);
const handleClose = () => setShow(false);
const handleShow = () => setShow(true);
const [alert, changeAlert] = useState({});


    return <ContextAlert.Provider value={{show, handleClose, handleShow, alert, changeAlert }}>
        {children}
    </ContextAlert.Provider>;
}

export {ContextAlert, ProviderAlert};